import { ModalHeader, FloraTypography, ModalBody, Flex, FloraButton } from '@grupoboticario/flora-react'

import ActionModal from '@/components/Modal/ActionModal'

import * as S from './ModalEditConfirmation.styles'

export const ModalEditConfirmation = ({
  openEditConfirmationModal,
  setOpenEditConfirmationModal,
  handleSubmit,
  isLoading
}: {
  openEditConfirmationModal: boolean
  setOpenEditConfirmationModal: (open: boolean) => void
  handleSubmit: () => void
  isLoading: boolean
}) => {
  return (
    <ActionModal
      css={S.modalWrapperCss}
      onOpenChange={setOpenEditConfirmationModal}
      open={Boolean(openEditConfirmationModal)}
      size="small"
    >
      <ModalHeader>
        <FloraTypography fontSize="title">Editar acelerador</FloraTypography>
      </ModalHeader>
      <ModalBody>
        <Flex direction="column" gap="$6">
          <FloraTypography fontSize="bodyLargeStandard" css={S.centeredTextCss}>
            Ao continuar, você confirma a edição desse acelerador.
          </FloraTypography>
          <Flex gap="$3">
            <FloraButton
              disabled={isLoading}
              isFull
              onClick={() => setOpenEditConfirmationModal(false)}
              hierarchy="secondary"
            >
              Voltar
            </FloraButton>
            <FloraButton disabled={isLoading} isFull isLoading={isLoading} onClick={handleSubmit}>
              Publicar edição
            </FloraButton>
          </Flex>
        </Flex>
      </ModalBody>
    </ActionModal>
  )
}
